import Component from "../../lib/component";
import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import swiperCss from 'swiper/css';
import swiperNavigationCss from 'swiper/css/navigation';
import swiperPaginationCss from 'swiper/css/pagination';

// Inject styles into the document head
const styleTag = document.createElement("style");
styleTag.textContent = [swiperCss, swiperNavigationCss, swiperPaginationCss].join("\n");
document.head.appendChild(styleTag);

export const RankingsSliderConfig = {
    componentTypeKey: 'RankingsSlider',
    baseHtmlClass: 'rankings_slider',
    selector: '.rankings_slider',

    datasetConfigKey: 'rankings_slider__config',

    slidesSelector: '.rankings_slider__slides',

    swiperHtmlClass: 'swiper',
    swiperSlidesWrapperHtmlClass: 'swiper-wrapper',
    swiperPaginationHtmlClass: 'swiper-pagination',
    swiperButtonNextHtmlClass: 'swiper-button-next',
    swiperButtonPrevHtmlClass: 'swiper-button-prev',
    swiperSlideHtmlClass: 'swiper-slide',
};

export class RankingsSlider extends Component {

    static get config() {
        return RankingsSliderConfig;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: RankingsSlider.config
        });

        this.setDatasetConfig(RankingsSlider.config.datasetConfigKey);

        this.slidesElement = this.element.querySelector(RankingsSlider.config.slidesSelector);

        buildSwiperElements(this.element, this.slidesElement);

        this.swiper = new Swiper(`.${RankingsSlider.config.swiperHtmlClass}`, {
            modules: [Navigation, Pagination],
            cssMode: true,
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1,
            spaceBetween: 0,
            breakpointsBase: 'container',
            breakpoints: {
                480: {
                    slidesPerView: 1,
                },
                650: {
                    slidesPerView: 2,
                },
                950: {
                    slidesPerView: 3,
                },
                1300: {
                    slidesPerView: 4,
                },
                1650: {
                    slidesPerView: 5,
                },
                2000: {
                    slidesPerView: 6,
                },
            },

            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            freeMode: {
                enabled: true,
                sticky: true,
            },

        });

        this.render();
    }

    render() {
    }

}

function buildSwiperElements(swiperElement, slidesWrapperElement) {
    if (swiperElement) {
        swiperElement.classList.add(RankingsSlider.config.swiperHtmlClass);
        swiperElement.insertBefore(buildSwiperPaginationElement(), null);
        swiperElement.insertBefore(buildSwiperButtonNextElement(), null);
        swiperElement.insertBefore(buildSwiperButtonPreviousElement(), null);
    }
    if (slidesWrapperElement) {
        slidesWrapperElement.classList.add(RankingsSlider.config.swiperSlidesWrapperHtmlClass);
        const slideElements = Array.from(slidesWrapperElement.children);
        slideElements.forEach((slideElement) => {
            slideElement.classList.add(RankingsSlider.config.swiperSlideHtmlClass);
        });
    }
}

function buildSwiperPaginationElement() {
    const element = document.createElement('div');
    element.classList.add(RankingsSlider.config.swiperPaginationHtmlClass);
    return element;
}

function buildSwiperButtonNextElement() {
    const element = document.createElement('div');
    element.classList.add(RankingsSlider.config.swiperButtonNextHtmlClass);
    return element;
}

function buildSwiperButtonPreviousElement() {
    const element = document.createElement('div');
    element.classList.add(RankingsSlider.config.swiperButtonPrevHtmlClass);
    return element;
}
